import * as React from "react";
import { Modal, Tabs } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { WorkloadContainerTabs } from "./container";
import { getDefaultContainerInput } from "./utils/utils";
import { formSetValue, formTriggerValidation, useCpFormValue } from "../../gvc/testNewForm/utils";
import { store } from "../../../store";
import { cloneDeep } from "lodash";
import { ContainerInput, WorkloadInput } from "../../../schema/types/workload/input";
import { TabLabel } from "./tabLabel";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CardTitle } from "../../../components/antd/card/CardTitle";

interface Props {}
export const WorkloadContainersTabs: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const containers: ContainerInput[] = useCpFormValue(`containers`);
  const activeKeyContainer: string = useCpFormValue(`meta.activeKeyContainer`);

  const onChange = (newActiveKey: string) => {
    formSetValue(id, `meta.activeKeyContainer`, newActiveKey);
  };

  const add = () => {
    const form = store.getState().form.instances[id];
    const values: WorkloadInput = form.values;

    const containers = values.containers;

    const defaultContainer = getDefaultContainerInput();
    defaultContainer.activeTabKey = `container-${containers.length}-image`;

    const _items = cloneDeep(containers);
    _items.push(defaultContainer);
    formSetValue(id, `containers`, _items);

    formSetValue(id, `meta.activeKeyContainer`, `container-${defaultContainer.id}`);

    formTriggerValidation(id);
  };

  const tryRemove = (targetKeyStr: React.MouseEvent | React.KeyboardEvent | string) => {
    Modal.confirm({
      title: "Remove Container",
      content:
        "You will lose the configuration you set up for this container, are you sure that you want to remove it?",
      onOk: () => remove(targetKeyStr),
    });
  };

  const remove = (targetKey: React.MouseEvent | React.KeyboardEvent | string) => {
    const form = store.getState().form.instances[id];
    const values: any = form.values;

    const containers = values.containers;
    let _items = cloneDeep(containers);
    const targetContainerId = (targetKey as string).split(`container-`)[1];
    _items = _items.filter((i) => i.id !== targetContainerId);
    formSetValue(id, `containers`, _items);

    let newActiveKey = activeKeyContainer;
    if (targetKey === activeKeyContainer) {
      for (const c of containers) {
        const containerActiveKey = `container-${c.id}`;
        if (containerActiveKey !== targetKey) {
          newActiveKey = containerActiveKey;
          break;
        }
      }
    }

    formSetValue(id, `meta.activeKeyContainer`, newActiveKey);

    formTriggerValidation(id);
  };

  const onEdit = (targetKey: React.MouseEvent | React.KeyboardEvent | string, action: "add" | "remove") => {
    if (action === "add") {
      add();
    } else {
      tryRemove(targetKey);
    }
  };

  return (
    <>
      <div className="cpln-form-section cpln-ant-tabs-container cpln-ant-card-container">
        <CardTitle>Containers</CardTitle>
        <Tabs
          type={"editable-card"}
          items={containers.map((container, index) => {
            const label = container.name.value || "Container";

            return {
              key: `container-${container.id}`,
              label: <TabLabel label={label} names={[`containers.${index}`]} />,
              children: <WorkloadContainerTabs key={container.id} index={index} />,
              closable: containers.length > 1,
            };
          })}
          onChange={onChange}
          activeKey={activeKeyContainer}
          onEdit={onEdit}
          hideAdd={containers.length >= 8}
          addIcon={
            <div className="flex items-center gap-2 px-4">
              <div>Add</div>
              <PlusOutlined />
            </div>
          }
        />
      </div>
    </>
  );
};
